export const COUNTRIES = [
  "Canada",
  "France",
  "North America",
  "Europe",
  "Asia-Pacific",
  "Middle East",
  "Africa",
  "South America",
  "China",
  "Japan",
  "South Korea",
  "Australia",
  "United Kingdom",
  "Germany",
  "India",
];

export const YEAR = [2020, 2021, 2022, 2023, 2024];

export const MANUFACTURER = {
  Tesla: ["Model X", "Model Y Long Range AWD", "Model Y Long Range RWD"],
  Polestar: [
    "2 Long range Dual Motor",
    "2 Long range Single Motor",
    "4 Long Range Dual Motor",
  ],
  Nissan: ["Ariya Engage", "Ariya Evolve e-4ORCE", "Leaf SV"],
  Audi: ["Q4 e-tron 45", "Q6 e-tron", "SQ8 e-tron quattro"],
};

export const REVISION = [1, 2, 3, 4, 5];
